import React , { Component } from 'react';
import {SharedConfig} from "../../Config/SharedConfig";


class ProductCardNoPic extends Component {
    render() {
        return(
            <div className={'product-card row justify-content-between '+((!this.props.isActive||!this.props.isForShow) ? "inactive" : "")}>
                <div className='col-8'>
                    <div>
                        <div className='title-box mobile-h5'>
                            { this.props.title }
                        </div>
                        <div className='description-box mobile-body-2-regular text-justified mt-custom-4'>
                            { this.props.description }
                        </div>
                    </div>
                </div>
                <div className='col-auto'>
                    <div className='price-box h-100'>
                        <div className='first-child align-items-center h-100'>
                            <div className='mobile-h5 cl-black'>
                                { this.props.price.toLocaleString() }
                            </div>
                            <div className='mobile-caption-strong cl-black '>
                                تومان
                            </div>
                        </div>
                        <div className='second-child mobile-h5 desktop-h5 text-start h-100 align-items-center' style={{"color" : "#83868B"}}>
                            {
                                !this.props.isActive
                                    ? "غیرفعال"
                                    : !this.props.isForShow ? "ناموجود" : ""
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ProductCardNoPic